import type { ApiEnvelope } from './types';

const REMOTE_API_BASE = 'https://pick7-worker.artubeditor.workers.dev';
const LOCAL_API_BASE = 'http://127.0.0.1:8787';
export const API_BASE = import.meta.env.VITE_PICK7_API_BASE || (import.meta.env.DEV ? LOCAL_API_BASE : REMOTE_API_BASE);

function devEmailHeader(): Record<string, string> {
  if (!import.meta.env.DEV) return {};
  const email = window.localStorage.getItem('pick7.devEmail') || '';
  return email ? { 'X-Debug-Email': email } : {};
}

export async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  for (const [key, value] of Object.entries(devEmailHeader())) headers.set(key, value);

  const response = await fetch(`${API_BASE}${path}`, { ...init, headers, credentials: 'include' });
  const envelope = (await response.json().catch(() => null)) as ApiEnvelope<T> | null;
  if (!response.ok || !envelope?.ok) {
    throw new Error(envelope?.error?.message || `API ${response.status}`);
  }
  return envelope.data as T;
}

export function toQuery(params: object): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params as Record<string, unknown>)) {
    if (value === undefined || value === null || value === '') continue;
    query.set(key, String(value));
  }
  const text = query.toString();
  return text ? `?${text}` : '';
}
